// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import axios from 'axios'//引入axios

import VueVideoPlayer from 'vue-video-player';

import WEBSITE_URL_OBJECT from './api/index';

import 'swiper/dist/css/swiper.css';  

Vue.use(VueAwesomeSwiper);
Vue.use(VueVideoPlayer);

Vue.prototype.$axios = axios;
Vue.prototype.$WEBSITE_URL_OBJECT = WEBSITE_URL_OBJECT;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js